/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2025-05-21 13:38:43
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\schedul\a.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/cloudSell/engineeringManagement/QueryPageElectronicFence'
export const queryPage2 = '/icps/system/sign/cloudSell/engineeringManagement/queryElectronicFencePage'

/*设置经纬度*/
// export function update_long_lat(params) {
//   return request({
//     url: '/icps/system/sign/cloudSell/engineeringManagement/update_long_lat',
//     method: 'get',
//     params
//   })
// }
/*设置电子围栏*/
export function update_distance(params) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/update_distance',
    method: 'get',
    params
  })
}
/*设置电子围栏经纬度距离*/
export function update_long_lat(params) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/update_long_lat',
    method: 'get',
    params
  })
}
/*获取站点项目距离 */
export function getStationToEngineeringDistance(params) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/getStationToEngineeringDistance',
    method: 'get',
    params
  })
}
/*保存站点项目距离 */
export function updateStationToEngineeringDistance(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/updateStationToEngineeringDistance',
    method: 'post',
    data
  })
}
/*获取泵送单位设置列表 */
export function pumpSetQuery(data) {
  return request({
    url: '/icps/system/sign/intelligent/projectPumpSet/query',
    method: 'post',
    data
  })
}
/*保存泵送单位设置列表 */
export function pumpSetSave(data) {
  return request({
    url: '/icps/system/sign/intelligent/projectPumpSet/save',
    method: 'post',
    data
  })
}
/*查询未绑定车辆 */
export function queryCarPage(data) {
  return request({
    url: '/icps/system/sign/basics/car/queryCarPage',
    method: 'post',
    data
  })
}
/*查询已绑定车辆 */
export function queryEngineeringCarPage(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringExtend/queryEngineeringCarPage',
    method: 'post',
    data
  })
}
/*绑定 */
export function addEngineeringCar(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringExtend/addEngineeringCar',
    method: 'post',
    data
  })
}
/*取消绑定 */
export function cancelEngineeringCar(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringExtend/cancelEngineeringCar',
    method: 'post',
    data
  })
}
